import { Typography } from '@optimus-web/core';
import { CardPaymentTableRecordData } from '@mews-commander/data-access';
import { useLocalizeText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { PaymentTerminalIcon } from './PaymentTerminalIcon';
import { useLocalizePaymentCardDetails } from './hooks';

export const PaymentCardCell = ({ paymentData }: { paymentData: CardPaymentTableRecordData }) => {
    const localizeText = useLocalizeText();
    const localizePaymentCardDetails = useLocalizePaymentCardDetails();

    const { paymentCardType, lastFourCardDigits } = paymentData;

    const paymentCardDetails =
        paymentCardType && lastFourCardDigits
            ? localizePaymentCardDetails(paymentData)
            : localizeText({ textKey: TextKey.Unspecified });

    return (
        <Typography textStyle="bodyMediumStrong" as="div">
            <PaymentTerminalIcon value={paymentData} />
            {UnicodeEntity.Space}
            {paymentCardDetails}
        </Typography>
    );
};
